import {
  AGE_TYPE_BOUNDS,
  SearchFilterComparisonOperator,
  SearchQueryFilters,
  FilterType,
  FilterTabs,
} from "~/hooks/search/types";
import { AgeType } from "reedy-data/api";

export const MAX_SELECT_ALL_ITEMS = 100;

export const defaultFilterValues: SearchQueryFilters = {
  keywordCount: {
    type: FilterType.NUMERIC,
    comparisonOperator: SearchFilterComparisonOperator.GREATER,
    value: undefined,
  },
  descriptionLength: {
    type: FilterType.NUMERIC,
    comparisonOperator: SearchFilterComparisonOperator.LESS,
    value: undefined,
  },
  descriptionWordCount: {
    type: FilterType.NUMERIC,
    comparisonOperator: SearchFilterComparisonOperator.LESS,
    value: undefined,
  },
  themaCodeCount: {
    type: FilterType.NUMERIC,
    comparisonOperator: SearchFilterComparisonOperator.LESS,
    value: undefined,
  },
  bisacCodeCount: {
    type: FilterType.NUMERIC,
    comparisonOperator: SearchFilterComparisonOperator.LESS,
    value: undefined,
  },
  publishedAt: {
    tab: FilterTabs.SPECIFIC,
    type: FilterType.DATE_RANGE,
    range: {
      from: "",
      to: "",
    },
  },
  ageRange: {
    ageType: AgeType.INTEREST_AGE_YEARS,
    range: { ...AGE_TYPE_BOUNDS[AgeType.INTEREST_AGE_YEARS] },
    type: FilterType.AGE_RANGE,
  },
  productGroupDescription: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  publisher: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  imprints: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  author: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  genre: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  keywords: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  themaCodes: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  bisacCodes: {
    values: [],
    type: FilterType.CHECKBOX,
  },
  salesData: {
    type: FilterType.SALES_DATA,
    range: {
      from: "",
      to: "",
    },
    totalUnits: {
      comparisonOperator: SearchFilterComparisonOperator.GREATER,
      value: undefined,
    },
    amazonOrderedUnits: {
      comparisonOperator: SearchFilterComparisonOperator.GREATER,
      value: undefined,
    },
    amazonConversionRate: {
      comparisonOperator: SearchFilterComparisonOperator.GREATER,
      value: undefined,
    },
  },
};
